import { render } from "./RecoverPassword.vue?vue&type=template&id=5d6cbf27&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"

import "./RecoverPassword.vue?vue&type=style&index=0&id=5d6cbf27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6cbf27"]])

export default __exports__